module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ResourcePage"
  }, [_c('header-component'), _vm._v(" "), _c('resource-services'), _vm._v(" "), _c('resource-suggest'), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c3e119d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c3e119d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Resource.vue
// module id = 538
// module chunks = 4